const Svg = ({ children, className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    {children}
  </svg>
);

export const LobbySportIcon = ({ name, className = "w777-sport-glyph" }) => {
  switch (name) {
    case "crash":
      return (
        <Svg className={className}>
          <path d="M3 13.5 11 8l2.2 1.2L21 5l-1.2 8.2L14 16l-2.5-1.4L5 18.5l-2-5z" />
        </Svg>
      );
    case "lottery":
      return (
        <Svg className={className}>
          <path d="M6 4h12v3H6V4zm0 5h12v11H6V9zm3 3v2h6v-2H9zm0 4v2h6v-2H9z" />
        </Svg>
      );
    case "exchange":
      return (
        <Svg className={className}>
          <path d="M4 7h11v2H7.4l2.3 2.3-1.4 1.4L4 10V7zm16 10H9v-2h7.6l-2.3-2.3 1.4-1.4L20 14v3z" />
        </Svg>
      );
    case "casino":
      return (
        <Svg className={className}>
          <path d="M5 5h14v4H5V5zm2 6h10v8H7v-8zm2 2v4h6v-4H9z" />
        </Svg>
      );
    case "slot":
      return (
        <Svg className={className}>
          <path d="M4 6h16v12H4V6zm3 2v2h2V8H7zm4 0v2h2V8h-2zm4 0v2h2V8h-2zM7 12v2h2v-2H7zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z" />
        </Svg>
      );
    case "fantasy":
      return (
        <Svg className={className}>
          <path d="M8 6h8a2 2 0 0 1 2 2v3h2v2h-2v5H6v-5H4v-2h2V8a2 2 0 0 1 2-2zm1 4h6V8H9v2z" />
        </Svg>
      );
    case "cricket":
      return (
        <Svg className={className}>
          <path d="M5 19 16 8l3 3L8 22 5 19zm12.8-9.9 1.1-1.1a1 1 0 0 0 0-1.4l-1.5-1.5a1 1 0 0 0-1.4 0l-1.1 1.1 2.9 2.9zM7 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
        </Svg>
      );
    case "football":
      return (
        <Svg className={className}>
          <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 4.3 2.4 1.4-1 1.7-2.4-1.4 1-1.7zm-3.1 2.2 2.4 1.4-1 1.7-2.4-1.4 1-1.7zm6.6 0 1 1.7-2.4 1.4-1-1.7 2.4-1.4zm-3.3 4.1 2.4 1.4-1 1.7-2.4-1.4 1-1.7z" />
        </Svg>
      );
    case "tennis":
      return (
        <Svg className={className}>
          <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 3a7 7 0 0 1 4.2 12.2 7 7 0 0 1-8.4 0A7 7 0 0 1 12 5z" />
        </Svg>
      );
    case "table-tennis":
      return (
        <Svg className={className}>
          <path d="M4 5h9a5 5 0 0 1 5 5v1h2v2h-2v2H8a5 5 0 0 1-5-5V5zm2 2v1a3 3 0 0 0 3 3h8.1A3 3 0 0 0 13 7H6zm12.5 9.5 2 2-1.4 1.4-2-2 1.4-1.4z" />
        </Svg>
      );
    case "esoccer":
      return (
        <Svg className={className}>
          <path d="M8 6h8a2 2 0 0 1 2 2v3h2v2h-2v5H6v-5H4v-2h2V8a2 2 0 0 1 2-2zm1 4h6V8H9v2z" />
        </Svg>
      );
    case "badminton":
      return (
        <Svg className={className}>
          <path d="m6 18 2-2 1.5 1.5-2 2-1.5-1.5zm10.8-11.3 1.1-1.1a1 1 0 0 0 0-1.4l-1.5-1.5a1 1 0 0 0-1.4 0l-1.1 1.1 2.9 2.9zM7 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
        </Svg>
      );
    default:
      return (
        <Svg className={className}>
          <circle cx="12" cy="12" r="8" />
        </Svg>
      );
  }
};

export const QUICK_TAB_ITEMS = [
  { label: "Sports Crash", icon: "crash" },
  { label: "Lottery", icon: "lottery" },
  { label: "Exchange", icon: "exchange" },
  { label: "Live Casino", icon: "casino" },
  { label: "Slot", icon: "slot" },
  { label: "Fantasy Games", icon: "fantasy" },
];

export const SPORT_STRIP_ITEMS = [
  { label: "Cricket", icon: "cricket" },
  { label: "Football", icon: "football" },
  { label: "Tennis", icon: "tennis" },
  { label: "Table Tennis", icon: "table-tennis" },
  { label: "Esoccer", icon: "esoccer" },
];

export const FEATURED_EVENTS = [
  { label: "FIFA WORLD CUP - WINNER 2026", icon: "football", tone: "sport-football" },
  { label: "England v India", icon: "cricket", tone: "sport-cricket" },
  { label: "FIFA WORLD CUP 2026 - SPECIAL", icon: "football", tone: "sport-football" },
];
